import { Component, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';
import { mask } from 'remask';
import { DATE_MASK } from '@shared/utils/moment-adapter.util';
import { CustomValidators } from '@shared/validators';

export interface DateRangeOptions {
  minDate?: Date;
  maxDate?: Date;
  icon?: 'prefix' | 'suffix';
}

@Component({
  selector: 'app-date-range-input',
  templateUrl: './date-range-input.component.html',
  styleUrls: ['./date-range-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DateRangeInputComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DateRangeInputComponent
    },
  ]
})
export class DateRangeInputComponent implements ControlValueAccessor, OnDestroy, Validator {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';
  
  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  dateRangeOptions?: DateRangeOptions = { icon: 'suffix' };

  onTouched: Function = () => {};
  
  public onChangeSubs: Subscription[] = [];
  public formGroup: FormGroup;

  constructor(formBuild: FormBuilder) {
    this.formGroup = formBuild.group({
      dataInicial: ['', CustomValidators.data],
      dataFinal: ['', CustomValidators.data]
    });
  }
 
  ngOnDestroy(): void {
    this.onChangeSubs.forEach(sub => sub.unsubscribe());
  }

  writeValue(obj: any): void {
    if(obj) {
      this.formGroup.setValue(obj, { emitEvent: false });
    } else {
      this.formGroup.reset();
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeSubs.push(this.formGroup.valueChanges.subscribe(
      ({ dataInicial, dataFinal }) => {
        if(!dataInicial || !dataFinal) {
          return fn(null);
        } 
        
        return fn([dataInicial, dataFinal]);
      }
    ));
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formGroup.disable() : this.formGroup.enable();
  }

  validate(c: FormControl): { [key: string]: any; } | null {
    return this.formGroup.valid ? null : { invalidForm: { valid: false, message: 'Data inválida' } };
  }

  onChange(event: any) {
    event.target.value = mask(event.target.value, DATE_MASK);
  }

  onBlur() {
    const dataInicial = this.formGroup.get('dataInicial');
    const dataFinal = this.formGroup.get('dataFinal');

    if(dataInicial?.invalid) {
      dataInicial.setValue('', { emitEvent: false, onlySelf: true });
    }

    if(dataFinal?.invalid) {
      dataFinal.setValue('', { emitEvent: false, onlySelf: true });
    }
  }
}
